import { computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertConfirmationDetailsComponent } from './alert-confirmation-details/alert-confirmation-details.component';
import { EditCustomPDFReportConfirmationDetailsComponent } from './edit-custom-pdf-report-confirmation-details/edit-custom-pdf-report-confirmation-details.component';
import { EditPortfolioConfirmationDetailsComponent } from './edit-portfolio-confirmation-details/edit-portfolio-confirmation-details.component';
import { UpdateWatchlistConfirmationDetailsComponent } from './update-watchlist-confirmation-details/update-watchlist-confirmation-details.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
function AgentToolPermissionBoxComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, "I wasn't able to ");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, ": ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.displayName());
} }
function AgentToolPermissionBoxComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, "Please confirm I have permission to ");
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " on your behalf. ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.displayName());
} }
function AgentToolPermissionBoxComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-update-watchlist-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolPermissionBoxComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-edit-portfolio-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolPermissionBoxComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-edit-custom-pdf-report-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolPermissionBoxComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-alert-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolPermissionBoxComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "button", 5);
    i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Conditional_7_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.dismiss()); });
    i0.ɵɵtext(3, "Dismiss");
    i0.ɵɵelementEnd()()();
} }
function AgentToolPermissionBoxComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "button", 5);
    i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Conditional_8_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.reject()); });
    i0.ɵɵtext(3, "Reject");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 7)(5, "button", 8);
    i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Conditional_8_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.authorize()); });
    i0.ɵɵtext(6, "Allow");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "label", 9)(8, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function AgentToolPermissionBoxComponent_Conditional_8_Template_input_ngModelChange_8_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r0.alwaysApply, $event) || (ctx_r0.alwaysApply = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "span", 11);
    i0.ɵɵelementStart(10, "span", 12);
    i0.ɵɵtext(11, "Always apply this answer");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.alwaysApply);
} }
export class AgentToolPermissionBoxComponent {
    constructor() {
        this.toolCall = input.required(...(ngDevMode ? [{ debugName: "toolCall" }] : []));
        this.confirm = output();
        this.alwaysApply = model(false, ...(ngDevMode ? [{ debugName: "alwaysApply" }] : []));
        this.displayName = computed(() => this.toolCall().display_name || this.toolCall().name, ...(ngDevMode ? [{ debugName: "displayName" }] : []));
        this.details = computed(() => this.toolCall().details ?? null, ...(ngDevMode ? [{ debugName: "details" }] : []));
        this.updateWatchlistDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'update_watchlist' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "updateWatchlistDetails" }] : []));
        this.editPortfolioDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'edit_portfolio' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "editPortfolioDetails" }] : []));
        this.editCustomPDFReportDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'edit_custom_pdf_report' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "editCustomPDFReportDetails" }] : []));
        this.alertDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'alert' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "alertDetails" }] : []));
        this.hasError = computed(() => !!this.details()?.error, ...(ngDevMode ? [{ debugName: "hasError" }] : []));
    }
    authorize() {
        this.confirm.emit({ authorize: true, alwaysApply: this.alwaysApply(), reason: null });
    }
    reject() {
        this.confirm.emit({ authorize: false, alwaysApply: this.alwaysApply(), reason: null });
    }
    dismiss() {
        const error = this.details()?.error ?? null;
        const reason = error ? `The action could not be prepared: ${error}` : null;
        this.confirm.emit({ authorize: false, alwaysApply: false, reason });
    }
}
AgentToolPermissionBoxComponent.ɵfac = function AgentToolPermissionBoxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentToolPermissionBoxComponent)(); };
AgentToolPermissionBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentToolPermissionBoxComponent, selectors: [["ycn-agent-tool-permission-box"]], inputs: { toolCall: [1, "toolCall"], alwaysApply: [1, "alwaysApply"] }, outputs: { confirm: "confirm", alwaysApply: "alwaysApplyChange" }, decls: 9, vars: 6, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4", "mt-20"], [1, "text-large", "leading-relaxed"], [3, "details"], [1, "row", "mt-3", "mb-3"], [1, "col-12"], [1, "btn", "btn-secondary", "btn-block", 3, "click"], [1, "row", "mt-3", "mb-10"], [1, "col-6"], [1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function AgentToolPermissionBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵconditionalCreate(1, AgentToolPermissionBoxComponent_Conditional_1_Template, 5, 1, "div", 1)(2, AgentToolPermissionBoxComponent_Conditional_2_Template, 5, 1, "div", 1);
        i0.ɵɵconditionalCreate(3, AgentToolPermissionBoxComponent_Conditional_3_Template, 1, 1, "ycn-update-watchlist-confirmation-details", 2);
        i0.ɵɵconditionalCreate(4, AgentToolPermissionBoxComponent_Conditional_4_Template, 1, 1, "ycn-edit-portfolio-confirmation-details", 2);
        i0.ɵɵconditionalCreate(5, AgentToolPermissionBoxComponent_Conditional_5_Template, 1, 1, "ycn-edit-custom-pdf-report-confirmation-details", 2);
        i0.ɵɵconditionalCreate(6, AgentToolPermissionBoxComponent_Conditional_6_Template, 1, 1, "ycn-alert-confirmation-details", 2);
        i0.ɵɵconditionalCreate(7, AgentToolPermissionBoxComponent_Conditional_7_Template, 4, 0, "div", 3)(8, AgentToolPermissionBoxComponent_Conditional_8_Template, 12, 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_1_0;
        let tmp_2_0;
        let tmp_3_0;
        let tmp_4_0;
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.hasError() ? 1 : 2);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional((tmp_1_0 = ctx.updateWatchlistDetails()) ? 3 : -1, tmp_1_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_2_0 = ctx.editPortfolioDetails()) ? 4 : -1, tmp_2_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_3_0 = ctx.editCustomPDFReportDetails()) ? 5 : -1, tmp_3_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_4_0 = ctx.alertDetails()) ? 6 : -1, tmp_4_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.hasError() ? 7 : 8);
    } }, dependencies: [FormsModule, i1.CheckboxControlValueAccessor, i1.NgControlStatus, i1.NgModel, AlertConfirmationDetailsComponent,
        EditCustomPDFReportConfirmationDetailsComponent,
        EditPortfolioConfirmationDetailsComponent,
        UpdateWatchlistConfirmationDetailsComponent], encapsulation: 2, changeDetection: 0 });
